import * as FareConditions from './components/FareConditions/FareConditions.css';
export default {
    FareConditions
};
